/**
 * Vanilla Next (vn) API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface BankAccountModel { 
    id?: number;
    bankId?: number;
    iban?: string;
    beneficiaryCode?: string;
    isDefault?: boolean;
    containerClass?: string;
    containerId?: number;
    'default'?: boolean;
}

